module.exports = __webpack_public_path__ + "img/ecole.31793ef6.png";